import React from "react";
import UlLi, {scrollTo, mountCode, initDeepLinkData} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import ApptokenDisplay from "js/utilities/get-display-apptoken";
import UserHandler from "js/utilities/user-handler";
import Zoom from "js/utilities/zoom-handler"
import { ZOOM_ICON } from "js/config.jsx";

import ENCRYPTION_KEY_JAVA from "resources/code/hybrid/android/07-set-encryption-key.java.tpl";
import SDK_INITIALIZE_JAVA from "resources/code/quickstart/android/00-initialize.java.tpl";
import SDK_START_ENROLLMENT_JAVA from "resources/code/quickstart/android/02-start-enrollment.java.tpl";
import SDK_GRADLE_CONFIG_JAVA from "resources/code/quickstart/android/00-gradle-config.java.tpl";
import SDK_MANUAL_CONFIG_JAVA from "resources/code/quickstart/android/01-gradle-manual-config.java.tpl";
import SDK_PERMISSIONS_JAVA from "resources/code/quickstart/android/16-permission.java.tpl";
import PROGUARD_CONFIG from "resources/code/android/30-proguard-config.java.tpl";
import CREATE_USER_AGENT_STRING_JAVA from "resources/code/android/create-api-user-agent-string.java.tpl";

export default React.createClass({
  displayName: "integration-guide",
  scrollToGuide : null,
  scrollingEl: null,
  getInitialState: function() {
    var data  = [{name: "Overview"},
                 {name: "Get Started"},
                 {name: "Requirements"},
                 {name: "Quickstart"},
                 {name: "Permissions"}
        ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data,
      navMenuParent: null,
      navMenu: null,
      android_release_version: "",
      android_release_date: "",
      ios_release_version: "",
      ios_release_date: "",
      server_java_release_version: "",
      server_java_release_date: "",
      server_c_release_version: "",
      server_c_release_date: "",
      zoom_web_release_version: "",
      zoom_web_release_date: "",
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    Zoom.getVersion(this);
  },

  render: function() {

    const android_release_version = this.state.android_release_version;
    const appToken = UserHandler.getAuth().appToken || "Sign up to get your own Device Key ."
    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;


    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">

              <section id="Overview">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2>FaceTec Device SDK Integration Guide - Overview</h2>
                </div>
                <hr />
                <p>The FaceTec&reg; Device SDKs make it <strong>dead simple</strong> to implement spoof-proof Liveness Detection and industry-leading face matching (Authentication and Duplicate Account Checks) into your applications. After <Link to="/downloads">downloading the Device SDKs</Link>, all you need to do is copy your <Link to="/account">your Device SDK Key  Identifier</Link>, paste it into the Sample App code, and run the Sample App!</p>
                <hr />
              </section>

              <section id="Get Started" className="getting-started-videos">
                <h3>Get Started with the FaceTec Device SDKs in less than 90 seconds.</h3>
                <p>Check out the 90 second integration videos for <a href="https://www.youtube.com/embed/7GzQdJ9Cin4" target="_blank">Android (seen below)</a>, <a href="https://www.youtube.com/embed/Zp5TdEtOJIo" target="_blank">Browser</a>, and <a href="https://www.youtube.com/embed/HyIjRG6hVVc" target="_blank">iOS</a>.</p>
                <p></p>
                <div className="embed-responsive embed-responsive-16by9" >
                  <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/7GzQdJ9Cin4" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>
                <p></p>
                <p></p>
              </section>

              <section id="Device Requirements">
                <br />

                <h3>Device Requirements</h3>
                <ul>
                  <li><p>Android 4.4+, iOS 8.3+, or Modern Browser.</p></li>
                  <li><p>Front-facing camera or webcam.</p></li>
                </ul>
                <p></p>
              </section>

              <section id="Development Requirements">
                <h3>Development Requirements</h3>
                <ul>
                  <li><p>Android Studio (Android), Xcode (iOS), Text Editor (Browser)</p></li>
                  <li><p>Android 4.4+</p></li>
                  <li><p>armv7, arm64</p></li>
                </ul>
                <p></p>
              </section>

              <section id="Quickstart">
                <h3>Test the Sample Apps!</h3>
                <p>Before integrating into your own app, it is useful to ensure that you can run our pre-configured Sample Apps:</p>
                <ol>
                  <li><p>Download and extract the SDK.</p></li>
                  <li><p>Open the <code>ZoomBasicApp</code> folder as a project in Android Studio.</p></li>
                  <li><p>Copy your Device SDK Key  Identifier from your <Link to="/account">Account Page</Link>.</p></li>
                  <li><p>Open <code>ZoomBasicActivity.java</code> and modify the <code>ZoomSDK.initialize</code> call to include your Device SDK Key  Identifier.</p></li>
                  <li><p>Run the app!</p></li>
                  <li><p>Perform similar steps to the above for our Complete App, which will demonstrate much more useful and interesting features of the FaceTec Device SDKs.</p></li>
                </ol>
                <p></p>
                <h3>Integrate FaceTec SDKs into Your App</h3>
                <p>To ensure the FaceTec Android Device SDK correctly compiles inside your application, the library must be placed in a location that is accessible by your application.  Then add the appropriate compile directives to your application's <code>build.gradle</code> files. As an example, follow these simple steps to start utilizing the FaceTec SDK in your existing project:</p>
                <ol>
                  <li><p>Place <code>zoom-authentication-{android_release_version}.aar</code> in a directory called "libs" in your project root</p></li>
                  <li><p>Add a <code>flatDir</code> directive to your top-level <code>build.gradle</code> file in the allprojects.repositories object</p></li>
                  <div className="code-container">
                    <CodeBlocks java={SDK_MANUAL_CONFIG_JAVA()}/>
                  </div>
                  <li><p>Add the compile directive to your application gradle file:</p></li>
                  <div className="code-container">
                    <CodeBlocks java={SDK_GRADLE_CONFIG_JAVA({android_release_version})}/>
                  </div>
                </ol>
                <blockquote>
                  <p>Additional examples of using the <code>flatDir</code> directive can be found in the gradle files for each of the sample apps provided in the FaceTec Android SDK. For more information on Build Configuration, please refer to the official Android Documentation <a href="https://developer.android.com/studio/build/index.html" target="_blank">here</a>.</p>
                </blockquote>
                <p></p>

                <h3>ProGuard</h3>
                <p>If your existing project uses ProGuard, you must exclude the FaceTec SDK library from being processed. You can do this by adding the following rules to your <code>proguard.cfg</code> configuration file:</p>
                <div className="code-container">
                  <CodeBlocks java={PROGUARD_CONFIG()}/>
                </div>
                <p></p>
              </section>

              <section id="Permissions">
                <h3>Android Permissions</h3>
                <p>The minimum Android SDK version needed to run FaceTec SDK is 18.  The FaceTec SDK requires camera permissions defined in the manifest to function properly.  Internet-related permissions are also required when using an HTTPS Key Check Key:</p>
                <div className="code-container">
                  <CodeBlocks java={SDK_PERMISSIONS_JAVA({appToken})}/>
                </div>
                <p></p>
                <blockquote>
                  <p><strong>Note</strong>: Although the {"<"}uses-feature{">"} elements for camera are listed in the manifest, they are not required. Any device, even those without a front camera, can install an application that uses Android FaceTec SDK. However, attempting to start a User Session with these devices is not possible because FaceTec SDKs initialization will return with a "Device Not Supported" status enum.</p>
                </blockquote>
              </section>

              <SDKSidebar menuType="main" title="Integration Guide"/>
            </div>
          </div>
        </div>
      </div>
    );
  }

});



// WEBPACK FOOTER //
// ./src/js/components/screens/integration-guide-overview.jsx